module.exports = __webpack_public_path__ + "img/guncases_off.5968f595.png";